// extracted by mini-css-extract-plugin
module.exports = {"backImg":"altAllDocs_backImg__qgpl9","sectionRow":"altAllDocs_sectionRow__VXw85"};